// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentName: 'test',
  baseApi: "https://test.actiafleet4agri.com/api",
  //baseApiCloud: "https://webapi-agri-test-agrirouter.azurewebsites.net/api/agrirouter",
  baseApiCloud: "https://func-agrirouter-api-test-westeu-001.azurewebsites.net/api",
  apiVersion: "1.18.0.0",
  clientVersion: "1.3.9.0",
  applicationVersion: "3.5.0",
  actiaSupportEmail: "actiasupport@actiaitalia.com",
  mailArgoTractors: "atfleetmanager@argotractors.com",
    mailUcontrol: "support@u-control.eu",
    mailCela: "info@cela.it", // TODO CELA: confermare
  actiaSupportPhone: "+39 02 93271399",
  hereApiKey: "wmD6vBkP3ZJNv78OUzcvWTIvBaaJETuZ3XBnrI_UGqE",
  keyStadia: 'c817d96a-c3b7-40bf-9c3b-0f9385be5d92',
  weatherApiKey: "c710589b0e3d4a193cbbae4a637a092a",
  hereUrl: 'maps.ls.hereapi.com',
  weatherApiUrl: 'maps.openweathermap.org',
  newGeoreverseHereURL: 'https://revgeocode.search.hereapi.com/v1/revgeocode',
  multiReverseHereUrl: 'https://reverse.geocoder.ls.hereapi.com/6.2/multi-reversegeocode.json',
  //georeverseHereUrl: 'https://reverse.geocoder.ls.hereapi.com/6.2/reversegeocode.json',
  orsServiceUrl: 'https://api.openrouteservice.org/geocode/',
  orsApiToken: '5b3ce3597851110001cf6248ff41dc332def43858dff1ecccdd19bbc',
  redirectUrlAgrirouter: 'https://test.actiafleet4agri.com/#/agrirouter/registry',
  redirectUrlAgrirouterAdministration: 'https://test.actiafleet4agri.com/#/agrirouter/administration',
  signalRUrl: 'https://test.actiafleet4agri.com/signalr/tracking/',
  webCallSignalRurl:'https://test.actiafleet4agri.com/signalr/webcall/',
  alertingSignalRUrl: 'https://test.actiafleet4agri.com/signalr/alerting/',
  baseUrl: 'https://test.actiafleet4agri.com/',

  baseTsOhwUrl: 'https://ohwapi.dts1.actiafleet.com/',
  baseReports: 'https://reportengine.dts1.actiafleet.com/be/', // 'http://192.168.1.208:9093/'
  powerBIreport: 'AGRI_Messages_Dev',
  powerBIreportCMA: 'AGRI_Messages_Dev',
  pBI_silentDevices: 'ReportSection7107c454e9edcf400eef',
  pBI_homepage: 'ReportSection5c97cba0d90375be3528',
  pBI_homepageCMA: 'ReportSection706828b0b5b30636894d',
  pBI_consumptionTrend: 'ReportSection5f5cf732128a39477472',
  pBI_deadlines: 'ReportSection576f8066dcfeab5dad52',
  powerBIFiltersVisible:true, // FZ per redere visibili i filtri di POwerBi
  powerBIFiltesExpand:false, // per rendere espansi i filtri di POwerBi
  refreshMillisecondsMaps: 120000,
  eventKeyCombination: 'ADMIN_ACTIA', //FZ #6268 Disabilitare scritture portale con codice
  actiaFooterText: 'ACTIA S.r.l. All rights reserved.',
  debugMode: true, // DEBUG: Bypass permission checks (set to false in production)

  // Rule Engine Configuration
  ruleEngine: {
    tenant: 'OHW',
    apiUrl: 'http://localhost:4000/api',
    mqttBrokerUrl: 'ws://localhost:9001', // WebSocket port for Mosquitto
    mqttNotificationTopic: 'ruleengine/notifications/#', // Topic for rule engine notifications
    mqttUsername: 'admin',
    mqttPassword: 'dariush',
    keycloak: {
      authority: 'https://dev-iam.actiaitaliaserviceprovider.com',
      realm: 'actiatest',
      clientId: 'ruleEngine-s2s-api',
      clientSecret: 'z59lJKTz0m2U9M1WHgkbIGA2vVRnvMYE',
      tokenEndpoint: 'https://dev-iam.actiaitaliaserviceprovider.com/realms/actiatest/protocol/openid-connect/token'
    }
  },

  // UControl - Bridge diagnostica veicoli (RP1210/MQTT) — punta all'unico ambiente collaudo disponibile per ora
  ucontrol: {
    apiUrl: 'https://uc-diaglight.dts1.actiafleet.com/api',
    swaggerUrl: 'https://uc-diaglight.dts1.actiafleet.com/swagger/index.html', // solo riferimento manuale, non usato a runtime
    mqttBrokerUrl: 'wss://mosquitto.dts1.actiafleet.com:443', // Mosquitto via WebSocket/TLS
    mqttUsername: 'mosquittouser',
    mqttPassword: 'mosquitto!', // TODO: valorizzare con WEBSOCKET_PASS reale
    sessionTopicPrefix: 'ws/sessions/', // deve combaciare con WSTopic.Topic lato Bridge
    keycloak: {
      authority: 'https://dev-iam.actiaitaliaserviceprovider.com',
      realm: 'actiatest',
      clientId: 'ucontrol-api-s2s',
      clientSecret: 'JlkLoWzhWSNHyUjLWcHb7aaKv0V4FdtY', // TODO: valorizzare con il client secret reale
      tokenEndpoint: 'https://dev-iam.actiaitaliaserviceprovider.com/realms/actiatest/protocol/openid-connect/token'
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
